import React from "react";
import {Modal, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";
import Loader from "../../../components/Loader";
import EventRuleForm from "./eventRuleForm";

const EventRuleModal = (props) => {
  const {data, open, onCancel} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit Event Rule" : "Add Event Rule"}</ModalHeader>
      <EventRuleForm data={data} onCancel={onCancel} />
    </Modal>
  );
};

EventRuleModal.propTypes = {
  open: PropTypes.bool,
};

export default EventRuleModal;
